$.fn.customTabs = function() {
    
    const jqAllAffectedContainers = this;

    jqAllAffectedContainers.each(function () {
        const tabsContainer = $(this);
        const tabsControlLinks = tabsContainer.find('.tab-selector a');
        const tabsContentContainers = tabsContainer.find('.tabs .tab');

        if (tabsControlLinks.length <= 0) {
            console.error('customTabs: no links found by selector ".tab-selector a"')
            return;
        }
        if (tabsContentContainers.length <= 0) {
            console.error('customTabs: no tab containers found by selector ".tab tab"')
            return;
        }

        tabsControlLinks.each(function() {
            const tabsControlLink = $(this);
            const tabID = tabsControlLink.attr('href');
            if (tabID.length <= 1) {
                console.warn('customTabs: invalid tabID in href', tabID);
                return;
            }
            const connectedTab = tabsContainer.find(tabID);
             if (connectedTab.length <= 0) {
                console.warn('customTabs: no tab found with id', tabID);
                return;
            }
            tabsControlLink.on('click', function(e) {
                e.preventDefault();
                tabsControlLinks.removeClass('current');
                tabsContentContainers.removeClass('current');
                tabsControlLink.addClass('current');
                connectedTab.addClass('current');
            });
        });
    });

    return this;
}

document.addEventListener('DOMContentLoaded', function(){
    $('.custom-tabs').customTabs();
});
